import { render, staticRenderFns } from "./AttachmentsButtonIfPresent.vue?vue&type=template&id=3ab0586c"
import script from "./AttachmentsButtonIfPresent.vue?vue&type=script&lang=ts"
export * from "./AttachmentsButtonIfPresent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports